import { RootState } from '@/store/store'
import { ChatPanelTabType } from './slice'

/** Select: whether the chat panel is open (vs collapsed) for this draft. */
export const selectChatPanelOpen = (state: RootState, props: { draftArtifactVersionId: string }): boolean => {
  // Open by default until the user collapses it for this draft.
  return state.draftWorkspaceState.chatPanelOpenByDraftArtifactVersionId[props.draftArtifactVersionId] ?? true
}

/** Select: the chat panel tab this draft was last on. */
export const selectChatPanelTab = (state: RootState, props: { draftArtifactVersionId: string }): ChatPanelTabType => {
  return state.draftWorkspaceState.chatPanelTabByDraftArtifactVersionId[props.draftArtifactVersionId] ?? ChatPanelTabType.Assistant
}

/** Select: the footnote number the open draft gives each source, keyed by agentV2SourceKey. */
export const selectDraftFootnoteNumberBySourceKey = (state: RootState) => state.draftWorkspaceState.draftFootnoteNumberBySourceKey
